<template src="./ConfigurationList.html"></template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("configuration");
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { notify, notifyApiError } from "@/utils/notification-helper";
import { MESSAGES } from "@/utils/constants";
import DialogBox from "@/components/DialogBox";
import DetailComponent from "./DetailComponent";
import Vue from "vue";
import { saveExcel } from "@progress/kendo-vue-excel-export";

export default {
  components: {
    DialogBox,
  },
  data: function () {
    return {
      title: null,
      gridHeight: window.innerHeight - 120,
      gridData: [],
      searchText: "",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "fieldName", dir: "asc" }],
      filteredColumns: [],
      dataItems: [],
      detailComponent: DetailComponent,
      columns: [
        { hidden: false, field: "name", title: "name", width: "150px", checked: true, defaultSelected: true,},
        { hidden: false, field: "description", title: "Description", width: "180px", checked: true, defaultSelected: true,},
        { hidden: false, field: "isDefault", cell: this.convertBoolean, title: "Default DB", width: "90px", checked: true, defaultSelected: true,},
        { hidden: false, field: "isSharedDb", cell: this.convertBoolean, title: "Shared DB", width: "100px", checked: true, defaultSelected: true,},
        { hidden: false, cell: CommandCell, width: '150px', locked: true, title: "Actions",  ignoreCheckbox: true, },
      ],
    }
  },
  methods: {
    getDataOnload() {
      this.$store.dispatch("configuration/getConfigurations", this.configurations);
      // this.$store.dispatch("configuration/getInitialData", this.initialData)
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    showAdd: function() {
      this.add = true;
    },
    convertBoolean: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, 'No');
      } else {
          return h("td", {}, 'Yes');
      }
    },
    goToAddPage: function() {
      this.$router.push({ name: "configurationAddUpdate", params: { add: true } });
    },
    goToAddDBPage: function() {
      this.$router.push({ name: "DBAddUpdate", params: { add: true } });
    },
    edit: function(item) {
      return this.$store.dispatch("configuration/editConfiguration", item.dataItem); //item.dataItem.id
    },
    remove: function(item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("configuration/deleteConfiguration", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
          this.getDataOnload()
        })
        .catch(notifyApiError);
    },
    expandChange(event) {
      const isExpanded =
        event.dataItem.expanded === undefined
          ? event.dataItem.aggregates
          : event.dataItem.expanded;
      Vue.set(event.dataItem, "expanded", !isExpanded);
      // });
    },
    exportExcel(){
      let arr = this.configurations.map(it => {
        return {      
          ...it,
          isDefault: it.isDefault ? "Yes": "No",
          isSharedDb: it.isSharedDb ? "Yes": "No",
        } 
      });
      saveExcel({
        data: arr,
        fileName: "Configuration",
        columns:this.columns
      });
    },
  },
  computed: {
    ...mapState(["loader", "configurations"]),
    congigurationListVal() {
      return this.configurations.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },
    items: {
      get: function () {
        return orderBy(
          this.congigurationListVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    total() {
      return this.configurations ? this.configurations.length : 0;
    },
  },
  mounted() {
    this.getDataOnload();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.CONFIGURATION_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({ ...col });
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  },
}
</script>
<style lang="scss" scoped>
.search_mobile {
  width: 15% !important;
  border-radius: 5px;
}
@media only screen and (max-width: 768px) {
  .search_mobile {
    width: 40% !important;
  }
  .mobile_hide_show {
    display: none;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    padding: 10px 10px 10px 10px;
  }
  .page-header .title-text {
    font-size: 12px;
  }
}
</style>